import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModel } from './base';
import { EExternalSource } from './external-sources';
import { EModel } from './model';
export let EReferralSource;
(function (EReferralSource) {
  EReferralSource["Upload"] = "upload";
  EReferralSource["PatientReferralForm"] = "patient-referral-form";
  EReferralSource["Ui"] = "ui";
  EReferralSource["Integrator"] = "integrator";
  EReferralSource["Followup"] = "followup";
  EReferralSource["Manual"] = "manual";
})(EReferralSource || (EReferralSource = {}));
export let EReferralStatusReason;
(function (EReferralStatusReason) {
  EReferralStatusReason["PatientUnreachable"] = "patient-unreachable";
  EReferralStatusReason["PatientCancelled"] = "patient-cancelled";
  EReferralStatusReason["InvalidInsurance"] = "invalid-insurance";
  EReferralStatusReason["MissingData"] = "missing-data";
  EReferralStatusReason["Other"] = "other";
})(EReferralStatusReason || (EReferralStatusReason = {}));
export let EReferralStatus;
(function (EReferralStatus) {
  EReferralStatus["Active"] = "active";
  EReferralStatus["Called"] = "called";
  EReferralStatus["CalledLate"] = "called-late";
  EReferralStatus["Scheduled"] = "scheduled";
  EReferralStatus["ScheduledLate"] = "scheduled-late";
  EReferralStatus["Incomplete"] = "incomplete";
  EReferralStatus["Expired"] = "expired";
  EReferralStatus["Cancelled"] = "cancelled";
  EReferralStatus["Pending"] = "pending";
  EReferralStatus["Closed"] = "closed";
})(EReferralStatus || (EReferralStatus = {}));
export let EReferralProcessedFollowup;
(function (EReferralProcessedFollowup) {
  EReferralProcessedFollowup["Pending"] = "pending";
  EReferralProcessedFollowup["Skipped"] = "skipped";
  EReferralProcessedFollowup["Failed"] = "failed";
  EReferralProcessedFollowup["Success"] = "success";
})(EReferralProcessedFollowup || (EReferralProcessedFollowup = {}));
export const fieldsReferral = _extends({}, fieldsIBaseModel, {
  acceptedAt: {
    type: 'Date'
  },
  appointmentType: {
    type: 'ID',
    ref: EModel.AppointmentType
  },
  attempt: {
    type: 'Number'
  },
  calledAt: {
    type: 'Date'
  },
  customerNotes: {
    type: 'Text'
  },
  customerRawSource: {
    type: 'Unknown'
  },
  departmentOrFacility: {
    type: 'Text'
  },
  diagnoses: {
    type: 'ID',
    ref: EModel.Diagnosis,
    array: true
  },
  duration: {
    type: 'Number'
  },
  expireAt: {
    type: 'Date'
  },
  externalId: {
    type: 'Option',
    values: EExternalSource
  },
  externalRawSource: {
    type: 'Unknown'
  },
  facility: {
    type: 'ID',
    ref: EModel.Facility
  },
  faxSentAt: {
    type: 'Date'
  },
  faxUpload: {
    type: 'ID',
    ref: EModel.FileUpload
  },
  fileUploads: {
    type: 'ID',
    ref: EModel.FileUpload,
    array: true
  },
  lastAttemptSentAt: {
    type: 'Date'
  },
  notes: {
    type: 'Text'
  },
  patient: {
    type: 'ID',
    ref: EModel.Patient
  },
  processedReferralFollowup: {
    type: 'Option',
    values: EReferralProcessedFollowup
  },
  provider: {
    type: 'ID',
    ref: EModel.Provider
  },
  reason: {
    type: 'Text'
  },
  referringProvider: {
    type: 'Text'
  },
  referringProviderFaxNumberOverride: {
    type: 'Text'
  },
  referringProviderId: {
    type: 'ID',
    ref: EModel.Provider
  },
  schedulableFacilities: {
    type: 'ID',
    ref: EModel.Facility,
    array: true
  },
  schedulableProviders: {
    type: 'ID',
    ref: EModel.Provider,
    array: true
  },
  schedulableProvidersScope: {
    type: 'Object',
    array: true
  },
  scheduledAt: {
    type: 'Date'
  },
  scheduledByAppointment: {
    type: 'ID',
    ref: EModel.Appointment
  },
  scheduledByOffer: {
    type: 'ID',
    ref: EModel.Offer
  },
  scheduleStartOn: {
    type: 'Date'
  },
  source: {
    type: 'Option',
    values: EReferralSource
  },
  startOn: {
    type: 'Date'
  },
  status: {
    type: 'Option',
    values: EReferralStatus
  },
  statusReason: {
    type: 'Option',
    values: EReferralStatusReason
  },
  statusReasonDescription: {
    type: 'Text'
  },
  upload: {
    type: 'ID',
    ref: EModel.Upload
  }
});